import { ClerkProvider } from "@clerk/clerk-react";
import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { resolveClerkPublishableKey } from "./clerk-env";
import "./index.css";
import { RootErrorBoundary } from "./RootErrorBoundary";
import { router } from "./router";

const clerkPk = resolveClerkPublishableKey();

function App() {
  const inner = <RouterProvider router={router} />;
  if (!clerkPk) {
    return inner;
  }
  return <ClerkProvider publishableKey={clerkPk}>{inner}</ClerkProvider>;
}

const el = document.getElementById("root");
if (!el) {
  throw new Error("root element missing");
}

createRoot(el).render(
  <StrictMode>
    <RootErrorBoundary>
      <App />
    </RootErrorBoundary>
  </StrictMode>,
);
